<template>
  <div
    class="flex flex-wrap border-b text-sm leading-none"
    :class="{
      'bg-negative-100 text-negative-900 border-negative-600' : error
    }"
  >
    <div
      class="w-2/3 p-3 border-r"
      :class="{
        'border-negative-600' : error
      }"
    >
      <label
        class="cursor-pointer"
        :for="id"
      >
        {{ details.label }}
      </label>
    </div>
    <div class="w-1/3 flex items-center">
      <span class="px-3 font-bold -mr-8">£</span>
      <input
        :id="id"
        :value="value"
        type="number"
        step=".01"
        min="0"
        required
        class="w-full pl-8 bg-transparent self-stretch focus:outline-none focus:shadow-outline text-right"
        v-bind="$attrs"
        @input="checkZero"
        @blur="checkZero"
      >
    </div>
    <div 
      v-if="error"
      class="w-full px-3 py-2 text-2xs text-negative-100 bg-negative-600"
    >
      <em>{{ details.errorMessage }}</em>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClaimsCalculatorRow',
  inheritAttrs: false,
  props: {
    value: {
      type: Number,
      required: true
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    details: {
      type: Object,
      required: true
    }
  },
  computed: {
    id() {
      const id = this.details.label.replace(/(\W)/, '_').toLowerCase()
      return `calculate_${id}`
    }
  },
  methods: {
    checkZero(e) {
        if(e.target.value > 0) return this.$emit('input', e.target.value)
        e.target.value = 0
        return this.$emit('input', 0)
    }
  }
}
</script>

<style>

</style>